<template>
  <div>
    <v-divider class="my-8 grey lighten-2" />

    <h4 class="mb-5 grey--text">
      {{ $t('appointment.label.status') }}
    </h4>

    <v-row dense>
      <v-col cols="3">
        <h6 class="text-uppercase grey--text">
          {{$t('appointment.statusTable.isServiceDone')}}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{ $t(`boolean.${item.done}`) }}
        </p>
      </v-col>
      <v-col>
        <h6 class="text-uppercase grey--text">
          {{$t('appointment.statusTable.reasonNotPerformed')}}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            item.not_done_comment
              ? item.not_done_comment
              : '---'
          }}
        </p>
      </v-col>
      <v-col v-if="isAdmin && reason" cols="3">
        <h6 class="text-uppercase grey--text">
          {{$t('appointment.statusTable.billable')}}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            reason.billable
              ? $t(`boolean.${reason.billable}`)
              : '---'
          }}
        </p>
      </v-col>
      <v-col v-if="isAdmin && reason" cols="3">
        <h6 class="text-uppercase grey--text">
          {{$t('appointment.statusTable.reopen')}}
        </h6>
        <p :class="dense ? 'caption' : 'body-2'">
          {{
            reason.reopen
              ? $t(`boolean.${reason.reopen}`)
              : '---'
          }}
        </p>
      </v-col>
    </v-row>

    <h6 class="text-uppercase grey--text mt-4">
      {{$t('appointment.statusTable.comment')}}
    </h6>
    <p :class="dense ? 'caption' : 'body-2'">
      {{
        item.comment
          ? item.comment
          : '---'
      }}
    </p>

    <h6 class="text-uppercase grey--text mt-4">
      {{$t('appointment.statusTable.photos')}}
    </h6>
    <div v-if="photos.length">
      <p v-for="(photo, index) in photos" :key="index">
        <a :href="photo.external_url" target="_blank">
          <img
            :src="photo.thumbnail_url"
            :alt="photo.filename"
            class="rounded ma-1"
            width="100"
          />
        </a>
      </p>
    </div>
    <p v-else class="body-2">---</p>
  </div>
</template>

<script>
export default {
  name: 'AppointmentRealtyStatus',

  props: {
    item: {
      type: Object,
      required: true,
    },

    dense: {
      type: Boolean,
      default: false,
    }
  },

  computed: {
    isAdmin() {
      return this.$route?.path.includes('admin')
    },

    reason() {
      return this.item?.reason
    },

    photos() {
      return this.item?.photos
    },
  }
}
</script>
